import { render, staticRenderFns } from "./EditMultipositionSlot.vue?vue&type=template&id=18223efa&scoped=true"
import script from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
export * from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
import style0 from "./EditMultipositionSlot.vue?vue&type=style&index=0&id=18223efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18223efa",
  null
  
)

export default component.exports